import actions from './actions'
import mutations from './mutations'
import getters from './getters'

export default {
    namespaced: true,
    state: {
    },
    actions,
    mutations,
    getters
};


// WEBPACK FOOTER //
// src/store/views/excel/index.js